import React, { useEffect, useState, Suspense } from "react";
import { fetchJSON } from "helpers/axios";
import { autoEllipses, copyTextToClipboard } from "helpers/helpers";
import { IconButton, CircularProgress } from "@material-ui/core";
import { FileCopyRounded } from "@material-ui/icons";
import { green } from "@material-ui/core/colors";
import { NotificationManager } from "react-notifications";
import GenericPdfDownloader from "applicant/routes/dashboard/downloadPDF";
import LoadingOverlay from "react-loading-overlay";

const SchoolFeesPaymentReceipt = ({ paymentReceipt, TransactionId }) => {
  const { payeeId, stateId, RRR } = paymentReceipt;
  const [schoolFeesPaymentItems, setSchoolFeesPaymentItems] = useState([]);
  const [res, setRes] = useState([]);
  const [resN, setResN] = useState([]);
  const [amountPaid, setAmountPaid] = useState([]);
  const [methodId, setMethodId] = useState([]);
  const [level, setLevel] = useState([]);
  const [loader, setLoader] = useState(false);

  const copyTransationRef = async (text) => {
    copyTextToClipboard(text);
    NotificationManager.success("Transaction Ref copied successfully");
  };

  useEffect(async () => {
    setLoader(true);
    try {
      const response = await fetchJSON(
        // `api/SchoolFeeChart?ApplicantId=${ApplicantID}`,
        `api/SchoolFeesReceipt0?RRR=${RRR}`,
        null,
        "GET"
      );
      if (
        typeof response === "object" &&
        response !== null &&
        !Array.isArray(response)
      ) {
        setSchoolFeesPaymentItems(response.Data?.details);
        setRes(response.Data?.totals1[0]?.total);
        setResN(response.Data?.totals0[0]?.total);
        setMethodId(response.Data?.MethodId);
        setAmountPaid(response.Data?.amountPaid);
        setLevel(response.Data?.Level);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }, []);

  return (
    <div className="mx-auto my-3 mb-3 container">
      <Suspense
        fallback={
          <div
            className="loader-view"
            style={{
              height: "calc(100vh - 250px)",
            }}
          >
            <CircularProgress />
          </div>
        }
      >
        <LoadingOverlay active={loader} spinner text="Loading...">
          <GenericPdfDownloader
            downloadFileName="ReceiptPDF"
            rootElementId="content"
          />
          <div className="mb-3 border border-2">
            <div className="container" id="content">
              <header
                className="mt-4 text-center"
                // style={{ borderBottom: "1px solid gray" }}
              >
                <div className="d-flex justify-content-between">
                  <div style={{ maxWidth: "100px", maxHeight: "100px" }}>
                    <img
                      className="img-fluid"
                      src="https://unicrossdoc.blob.core.windows.net/passport/UNICROSS%20Logo%20-%20whitebg.png?sp=r&st=2022-10-17T15:19:36Z&se=2122-10-17T23:19:36Z&spr=https&sv=2021-06-08&sr=b&sig=TlwLNipSBRc%2BhjvTbnacUYmgEvo1H7s41Jd5tHqYMkE%3D"
                      alt=""
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  </div>
                  <div>
                    <h3 style={{ fontSize: "18px" }}>
                    Babalola Academy Collage of Health Technology, Ilorin
                    </h3>
          
                    <h5 style={{ fontSize: "16px" }}>
                      https://www.babalolacollege.edu.ng
                    </h5>
                  </div>
                  <div style={{ maxWidth: "100px", maxHeight: "100px" }}>
                    {/* <h1>{paymentReceipt.passport}</h1> */}
                    <img
                      className="img-fluid"
                      src={
                        paymentReceipt?.passport != null
                          ? paymentReceipt.passport
                          : "https://unicrossdoc.blob.core.windows.net/passport/Avatar.jpg"
                      }
                      alt="Sorry Image not Uploaded!!!"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  </div>
                </div>
              </header>

              <div className="mb-2 text-center text-center border-bottom">
                <h1>
                  <strong>Student Payment Receipt</strong>
                </h1>
              </div>

              <div className="border-bottom">
                <div className="row">
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>FULL NAME:</h2>
                      </div>
                      <div className="col-md-8 text-uppercase">
                        <h2>{paymentReceipt?.name}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>MATRIC NO:</h2>
                      </div>
                      <div className="col-md-8">
                        <strong>{paymentReceipt?.jambRegNo}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>ADMISSION SET:</h2>
                      </div>
                      <div className="col-md-8">
                        <h2>{paymentReceipt?.admittedSession}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>PROGRAM:</h2>
                      </div>
                      <div className="col-md-8">
                        <h2>{paymentReceipt?.program}</h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>DEPARTMENT:</h2>
                      </div>
                      <div className="col-md-8">
                        <h2>{paymentReceipt?.department}</h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>SESSION:</h2>
                      </div>
                      <div className="col-md-8">
                        <strong>{paymentReceipt?.session}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>COURSE OF STUDY:</h2>
                      </div>
                      <div className="col-md-8">
                        <strong>{paymentReceipt?.courseOfStudy}</strong>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>LEVEL</h2>
                      </div>
                      <div className="col-md-8">
                        <strong>{level}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-2">
                <div className="row">
                  <div className="col-md-7">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>DATE OF PAYMENT:</h2>
                      </div>
                      <div className="col-md-8 text-uppercase">
                        <h2>
                          <strong className="text-end">
                            {new Date(
                              paymentReceipt?.paymentDate
                            ).toLocaleString()}
                          </strong>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <div className="col-md-4">
                        <h2>RECEIPT NO:</h2>
                      </div>
                      <div className="col-md-8">
                        <strong>
                          <div className="d-flex align-items-center my-0">
                            <span>
                              TransactionId:
                              {autoEllipses(TransactionId ?? "", "200", "90")}
                            </span>
                            <IconButton
                              onClick={() => copyTransationRef(TransactionId)}
                            >
                              {" "}
                              <FileCopyRounded
                                style={{ color: green[500], fontSize: "16px" }}
                              />{" "}
                            </IconButton>
                          </div>
                        </strong>
                        <p>
                          <strong>RRR: {paymentReceipt?.RRR}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <table className="w-100">
                <thead>
                  <tr>
                    <th scope="col">NAME</th>
                    {/* <th scope="col">DESCRIPTION</th> */}
                    <th scope="col">AMOUNT(NGN)</th>
                  </tr>
                </thead>
                <tbody className="table table-bordered">
                  {schoolFeesPaymentItems?.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.PaymentName}</td>
                        {/* <td> {item.PaymentName}</td> */}
                        <td>
                          {stateId == "2656"
                            ? item.IndigeneAmount
                            : item.NonIndigeneAmount}
                        </td>
                      </tr>
                    );
                  })}

                  <tr>
                    <td className="font-weight-bold text-right">
                      <span>
                        TOTAL FEES: (
                        {methodId == "1"
                          ? "FULL PAYMENT"
                          : "INSTALLMENTAL PAYMENT"}
                        )
                      </span>
                    </td>
                    <td>
                      <span>{stateId == "2656" ? res : resN}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="text-right">
                      <span>
                        <strong>AMOUNT PAID:</strong>
                      </span>
                    </td>
                    <td>
                      <span>{amountPaid}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />
          <div className="d-flex justify-content-between mb-5 mt-1">
            <div>
              <h5 className="text-muted" style={{ fontSize: "20px" }}>
                <i>
                  <strong>Verify Documentf</strong>
                </i>
              </h5>
              <div>
                {/* <h1>{paymentReceipt.passport}</h1> */}
                <img
                  className="img-fluid"
                  src={paymentReceipt?.QRcode}
                  alt=""
                  style={{ maxWidth: "130px", maxHeight: "130px" }}
                />
              </div>
            </div>
            <div className="mx-3">
              <strong>
                <h5 className="text-muted" style={{ fontSize: "20px" }}>
                  Payment Methods:
                </h5>
              </strong>
              <img
                src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(17).png"
                alt=""
                style={{ height: "50%", width: "80%", objectFit: "" }}
              />
            </div>
            <div className="mb-5">
              <img
                src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(16).png"
                alt=""
                style={{ height: "80%", width: "80%" }}
              />
            </div>
          </div>
            </div>
          </div>
        </LoadingOverlay>
      </Suspense>
    </div>
  );
};

export default SchoolFeesPaymentReceipt;
